import Storage from '@/lib/storage';
// import { deepCopy } from '@yanxiu/lib'
// import { routeStatic } from '@/router/routes-static.js.old';
import { staticRoutes } from '@/router';
import { checkIsSuperBrand } from '@/lib/tools';
import { getIsXichengBrand } from '@/hooks/useIsXichengBrand';
import dayjs from 'dayjs';

const ss = new Storage('sessionStorage');
const ls = new Storage('localStorage');
const Cookies = new Storage('cookie');


/**
 * 重新遍历菜单组装数据
 */
function refreshMenu(menus, routesMap, rootId = 0) {
    let currentMenus = [];
    if (menus.length) {
        menus.forEach(item => {
            let menuItem = {
                title: item.custom_name || item.name, // 菜单项名称
                key: item.id, // 菜单项唯一值, 用路由名 命名
                id: item.id,
                parentId: rootId, // 父id
                link: item.link, // 外链
                link_type: item.link_type, // 1 应用  2 链接
                moduleKey: item.moduleKey,
                custom_name: item.custom_name || '',
            };
            if (item.moduleKey) {
                // menuItem.route = routesMap[item.moduleKey] || {};
                menuItem.route = { path: routesMap[item.moduleKey] } || {};
            }
            if (item.moduleKey === 'home') {
                // 首页
                menuItem.route = { path: '/idx/home' } || {};
            }
            menuItem.path = (menuItem.route && menuItem.route.path) || menuItem.link;

            if (item.sub_navs && item.sub_navs.length) {
                menuItem.sub_navs = refreshMenu(item.sub_navs, routesMap, item.id);
            }
            currentMenus.push(menuItem);
        });
    }
    return currentMenus;
}

function getKey(list, obj) {
    (list || []).forEach(item => {
        obj[item.permissionKey] = true;
        if (item.children?.length) {
            getKey(item.children, obj);
        }
    });
    return obj;
}

const state = {
    initialized: false, // true 初始化完成
    initUserInfo: false, // 是否查询了用户
    menuList: [], // 导航菜单
    realMenuList: [], // 拼接好的路由
    currentMenu: {}, // 当前路径对应菜单
    activeMenu: {}, // 高亮菜单
    currentTabs: [], // 当前路径对应的 tabs
    crumbData: [], // 面包屑
    isHaveIdmx: false, // 是否有管理中心的权限
    isHaveSmc: false, // 是否有新管理中心的权限
    isHaveStrain: false, // 是否有继教权限
    fromTemplateId: '1', // 导航及底部模板
    listMenu: [], // 用户菜单权限
    btnPermission: [], // 有授权的按钮key组成的列表,
    backendBtnPermission: [], // 有授权的按钮key组成的列表,
    teacherAuthConfig: {}, // 是否可以修改用户信息的配置
    personalInstitutions: [], // 用户站点信息列表
    isDashboardAdmin: false, // 是否工作台管理员
};

const getters = {
    // 用户导航（即该用户角色权限的菜单）
    userMenus: state => {
        return state.realMenuList || [];
    },
    // 用户所有菜单对象，key: moduleKey, value：menu
    userAllMenuObj: state => {
        const list = state.realMenuList || [];
        const result = {};
        list.forEach(item => {
            (item.sub_navs || []).forEach(subItem => {
                result[subItem.moduleKey] = subItem;
            });
            result[item.moduleKey] = item;
        });
        return result;
    },
};

const actions = {
    init({ commit, dispatch, rootState }) {
        return new Promise((resolve, reject) => {
            dispatch('getUserPermissions')
                .then(() => {
                    resolve();
                })
                .catch(err => {
                    reject(new Error(err));
                });
        });
    },
    getMemberUserV3(context) {
        const { commit, rootState, dispatch } = context;
        const accessToken = Cookies.getItem(
            checkIsSuperBrand() ? 'super-wand-X-DT-accessToken' : 'X-DT-accessToken',
        );
        // 如果是西城就不调用
        if (accessToken && !getIsXichengBrand(rootState.brand)) {
            dispatch('checkDashboardAdmin')
        }
        if (accessToken && Object.keys(rootState.memberUserV3).length == 0) {
            G_transmit('getMemberInfoV3', {
                name: 'getMemberInfoV3',
                queries: {},
                message: false,
            }).then(res => {
                if (res.data) {
                    commit(
                        'meta',
                        {
                            memberUserV3: res.data,
                        },
                        {
                            root: true,
                        },
                    );
                    // 存入 localStorage
                    ls.setItem('memberInfoV3', res.data);
                }
            });
        }
    },
    // 获取当前登录用户信息
    getCurrentUser({ commit, dispatch, rootState }, isRefresh = true) {
        let accessToken = Cookies.getItem('X-DT-accessToken') || '';
        if (!accessToken) {
            return;
        }
        return new Promise((resolve, reject) => {
            if (rootState.currentUser.userId && isRefresh) {
                return resolve(rootState.currentUser);
            }
            dispatch('getIdmxPermissions');
            dispatch('getUserPermissionListSiteMenu');
            dispatch('getUserButtonPermission');
            dispatch('getUserBackendButtonPermission');
            dispatch('getPersonalInstitution');
            G_transmit('getCenterUserInfo', {})
                .then(res => {
                    let data = res.data || {};
                    commit(
                        'meta',
                        {
                            currentUser: data,
                        },
                        {
                            root: true,
                        },
                    );
                    commit('setState', {
                        key: 'initUserInfo',
                        value: true,
                    });
                    const loginDate = dayjs(new Date()).format('YYYY-MM-DD');
                    window.posthog?.identify(
                        data.userId,                       // distinct_id
                        { name: data.name },               // userProperties（每次都会更新）
                        { first_login_date: loginDate }        // userPropertiesSetOnce（仅首次写入）
                    );

                    resolve(data);
                })
                .catch(err => {
                    reject(err);
                });
        });
    },
    // 获取用户导航菜单
    getUserPermissions({ state, commit, dispatch }) {
        return Promise.all([dispatch('getNavList'), dispatch('getModuleList')]).then(resArr => {
            if (resArr?.length > 1) {
                commit('setState', {
                    key: 'initialized',
                    value: true,
                });
                commit('setState', {
                    // 原始导航数据
                    key: 'menuList',
                    value: resArr[0],
                });
                let realMenuList = refreshMenu(resArr[0], resArr[1], 0);
                commit('setState', {
                    // 最终的导航数据
                    key: 'realMenuList',
                    value: realMenuList,
                });
            }
        });
    },
    getNavList({ state, commit, dispatch }) {
        // 获取导航顺序及名称
        return new Promise((resolve, reject) => {
            G_transmit('getNavContent', {
                name: 'getNavContent',
                queries: {
                    componentTypes: 'navigation',
                    client: 'pc',
                },
            })
                .then(res => {
                    let navData = res?.data?.navigation || {};
                    let list = navData.data ? JSON.parse(navData.data) : [];
                    commit('setState', {
                        // 站点模板
                        key: 'fromTemplateId',
                        value: navData.fromTemplateId || '',
                    });
                    commit('setState', {
                        // 导航模板
                        key: 'navTemplateId',
                        value: navData.navTemplateId || '',
                    });
                    resolve(list);
                })
                .catch(err => {
                    reject(err);
                });
        });
    },
    // 获取应用列表
    getModuleList({ state, commit, dispatch }) {
        return new Promise((resolve, reject) => {
            G_transmit('getModuleUrl', {})
                .then(res => {
                    resolve(res.data || {});
                })
                .catch(err => {
                    reject(err);
                });
        });
    },
    // 获取用户管理中心的菜单
    getIdmxPermissions({ state, commit, dispatch }, userId) {
        return new Promise((resolve, reject) => {
            G_transmit('getUserMenu', {
                queries: {
                    sysList: 'siteAdmin,education,szSiteAdmin',
                },
            })
                .then(res => {
                    let mapArr = {};
                    res.data?.length &&
                        res.data.forEach(item => {
                            mapArr[item.sys] = item.hasPermission;
                        });
                    commit('setState', {
                        key: 'isHaveIdmx',
                        value: mapArr.siteAdmin,
                    });
                    commit('setState', {
                        key: 'isHaveSmc',
                        value: mapArr.szSiteAdmin,
                    });
                    console.log(mapArr.szSiteAdmin, 'mapArr.szSiteAdmin');
                    commit('setState', {
                        key: 'isHaveStrain',
                        value: mapArr.education,
                    });
                    resolve(res);
                })
                .catch(err => {
                    reject(err);
                });
        });
    },

    // 获取用户前台的菜单
    getUserPermissionListSiteMenu({ state, commit, dispatch }, userId) {
        return new Promise((resolve, reject) => {
            G_transmit('getUserPermissionListSiteMenu', {
                queries: {
                    sys: 'siteFront',
                },
            })
                .then(res => {
                    let mapArr = getKey(res.data, {});
                    commit('setState', {
                        key: 'listMenu',
                        value: mapArr,
                    });
                    resolve(res);
                })
                .catch(err => {
                    reject(err);
                });
        });
    },

    // 获取用户对于站点的按钮权限
    async getUserButtonPermission({ state, commit, dispatch }, userId) {
        const res = await G_transmit('getSiteButtonPermission', {
            queries: { sys: 'siteFront' },
        });
        const permissionKeyList = (res.data || []).filter(item => item.tag).map(item => item.key);
        commit('setState', {
            key: 'btnPermission',
            value: permissionKeyList,
        });
    },
    // 获取用户对于站点的按钮权限
    async getUserBackendButtonPermission({ state, commit, dispatch }, userId) {
        const res = await G_transmit('getSiteButtonPermission', {
            queries: { sys: 'education' },
        });
        const permissionKeyList = (res.data || []).filter(item => item.tag).map(item => item.key);
        commit('setState', {
            key: 'backendBtnPermission',
            value: permissionKeyList,
        });
    },
    // 刷新菜单 & 权限
    reload() {
        window.location.reload();
    },
    reloadMenu({ dispatch, rootState }) {
        dispatch('getUserPermissions');
    },
    // 获取用户导航菜单
    getUnreadMessage({ state, commit, dispatch }) {
        return new Promise((resolve, reject) => {
            G_transmit(
                'getUnreadNums',
                {
                    queries: {
                        systemCodes: '1000,2000,3000,4000,5000,6000,7000,9000',
                    },
                },
                {
                    root: true,
                },
            )
                .then(res => {
                    let data = res.data || { like: 0, message: 0 };
                    commit(
                        'meta',
                        {
                            unreadMessage: data,
                        },
                        {
                            root: true,
                        },
                    );
                    resolve(data);
                })
                .catch(err => {
                    reject(err);
                });
        });
    },
    // 获取用户是否可以修改用户信息的配置
    getTeacherAuthConfig({ state, commit }) {
        return new Promise((resolve, reject) => {
            if (Object.keys(state.teacherAuthConfig).length) {
                return resolve(state.teacherAuthConfig);
            }
            G_transmit(
                'getTeacherAuth',
                {},
                {
                    root: true,
                },
            )
                .then(res => {
                    let data = res.data || {};
                    commit('setState', {
                        key: 'teacherAuthConfig',
                        value: data,
                    });
                    resolve(data);
                })
                .catch(err => {
                    reject(err);
                });
        });
    },
    // 获取用户站点信息
    getPersonalInstitution({ state, commit }) {
        return new Promise((resolve, reject) => {
            if (state.personalInstitutions?.length) {
                return resolve(state.personalInstitutions);
            }
            G_transmit(
                'getPersonalInstitution',
                {},
                {
                    root: true,
                },
            )
                .then(res => {
                    commit('setState', {
                        key: 'personalInstitutions',
                        value: res?.data || [],
                    });
                })
                .catch(err => {
                    console.error(err);
                    resolve([]);
                });
        });
    },
    async checkDashboardAdmin({ commit }) {
        try {
            const res = await G_transmit('isDashboardAdmin', {
                name: 'isDashboardAdmin',
                message: false,
            });
            commit('setState', {
                key: 'isDashboardAdmin',
                value: res.data,
            });
        } catch (e) {
            console.error(e);
        }
    },
};

const mutations = {
    setState: (state, data) => {
        state[data.key] = data.value;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
